import React, { useMemo } from 'react';
import { Box, Stack, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { CheckCircleRounded, CancelRounded, LocalShipping, HourglassEmpty } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';

const JobsViewToggle = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const STATUS = [
    { value: 'Preparing Vehicles', label: 'Preparing Vehicles', shortLabel: 'Preparing' },
    { value: 'Loading Vehicles', label: 'Loading Vehicles', shortLabel: 'Loading' },
    { value: 'Finished', label: 'Finished', shortLabel: 'Finished' },
    { value: 'Canceled', label: 'Canceled', shortLabel: 'Canceled' },
  ];

  const values = useMemo(
    () => ({
      Status: searchParams.get('Status') || 'Preparing Vehicles',
    }),
    [searchParams]
  );

  const setParam = (k, v) => {
    const next = new URLSearchParams(searchParams);
    if (v === '' || v == null) next.delete(k);
    else next.set(k, v);
    next.set('PageNumber', '0');
    setSearchParams(next);
  };

  return (
    <Box sx={{ mt: 3, display: 'flex', alignItems: 'start' }}>
      <ToggleButtonGroup
        value={values.Status}
        exclusive
        onChange={(e, val) => {
          if (val) setParam('Status', val);
        }}
        size="medium"
        sx={{ flexWrap: 'wrap', gap: 1.5 }}
      >
        {STATUS.map((s) => {
          const selected = values.Status === s.value;
          const ui =
            s.value === 'Finished'
              ? { bg: '#E8F5E9', fg: '#2E7D32', border: '#A5D6A7', iconComp: CheckCircleRounded }
              : s.value === 'Canceled'
              ? { bg: '#FFEBEE', fg: '#C62828', border: '#EF9A9A', iconComp: CancelRounded }
              : s.value === 'Loading Vehicles'
              ? { bg: '#E3F2FD', fg: '#1565C0', border: '#90CAF9', iconComp: LocalShipping }
              : { bg: '#FFF8E1', fg: '#EF6C00', border: '#FFCC80', iconComp: HourglassEmpty };
          const Icon = ui.iconComp;

          return (
            <ToggleButton
              key={s.value}
              value={s.value}
              sx={{
                minWidth: { xs: 44, sm: 160 },
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 3,
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                borderColor: selected ? ui.border : 'divider',
                bgcolor: selected ? ui.bg : 'background.paper',
                color: selected ? ui.fg : 'text.secondary',
                boxShadow: selected ? 2 : 0,
                transition: 'all 0.25s ease-in-out',
                '&:hover': {
                  bgcolor: selected ? ui.bg : 'action.hover',
                  transform: 'translateY(-2px)',
                  boxShadow: 2,
                },
              }}
            >
              <Stack direction="row" spacing={isXs ? 0.5 : 1} alignItems="center" justifyContent="center">
                <Icon fontSize={isXs ? 'small' : 'medium'} />
                {!isXs ? <span>{s.label}</span> : <span>{s.shortLabel}</span>}
              </Stack>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Box>
  );
};

export default JobsViewToggle;
